import { createContext } from 'react';

const reporteContext = createContext();

export default reporteContext;
